import { useEffect, useState } from "react";
import API from "../ApiConfig"
import { localDataKeys, SET_LAYOUT } from "../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import { MESSAGE } from "../Utils/Strings";
import { IssuerDate, resetDocument, setDate } from "../Utils/helper";

const useNavigationBlocker = (id, docName, template_content, layout, Sign, background, issuer_id, Icon, Address, page_number) => {

    const saveDraft = () => {
        let data = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))
        let temp = data.page_layout[page_number - 1]
        temp['layout'] = JSON.stringify(layout)
        temp['template_content'] = layout.filter(item => item.name === 'content').map(item => item.content).join('')
        temp['background'] = background.url
        temp['signature'] = Sign.url
        temp['opacity'] = background.opacity || 1
        data['page_layout'][page_number - 1] = temp
        localStorage.setItem(localDataKeys.DOCUMENT_DRAFT, JSON.stringify(data))
    };

    // Save to localstorage after every 500 ms
    useEffect(() => {
        const timer = setTimeout(() => {
            saveDraft();
            // SaveDocument(page_number)
        }, 1000)
        return () => {
            clearTimeout(timer);
        };
    });


    useEffect(() => {
        let page = page_number - 1

        if (page_number <= 1) {
            page = page_number
        }
        const docSave = setTimeout(() => {
            // saveDraft();
            SaveDocument(page)
        }, 5000)
        return () => {
            clearTimeout(docSave);
        };
    }, [page_number]);


    useEffect(() => {
        const autosave = setTimeout(() => {
            SaveDocument(page_number)
        }, 5000)
        return () => {
            clearTimeout(autosave);
        };
    });

    useEffect(() => {
        localStorage.setItem(localDataKeys.SAVED, false);
    }, [id, docName, template_content, layout, Sign, background, issuer_id, Icon, Address, page_number])

    useEffect(() => {
        const isSaved = () => {
            let save = localStorage.getItem(localDataKeys.SAVED)
            if (save == 'false')
                cogoToast.info(MESSAGE.SAVED_LOCALLY)
            if (save == 'true') {
                resetDocument()
            }
        }
        return () => {
            isSaved()
        };
    }, []);

    // useEffect(() => {
    //     return () => {
    //         setTimeout(() => {
    //             let save = localStorage.getItem(localDataKeys.SAVED)
    //             if (save == 'false')
    //                 cogoToast.info(MESSAGE.SAVED_LOCALLY)
    //             if (save == 'true') {
    //                 localStorage.removeItem(localDataKeys.DRAFT)
    //                 localStorage.removeItem(localDataKeys.DOCUMENT_DRAFT)
    //             }
    //         }, 100);
    //         // submitDesign()
    //     }
    // }, [])

    // useEffect(() => {
    //     const saveDoc = () => {
    //         localStorage.setItem(localDataKeys.DOCUMENT_DRAFT, JSON.stringify(document));
    //     }
    //     saveDoc()
    // }, [document])

    const SaveDocument = (page_number) => {
        let document = JSON.parse(localStorage.getItem(localDataKeys.DOCUMENT_DRAFT))
        let doc = document.page_layout[page_number - 1]

        const formData = new FormData();

        formData.append('doc_id', doc.doc_id)
        formData.append('page_number', page_number)
        formData.append('opacity', doc.opacity)
        formData.append('title', "Title")
        formData.append('template_content', doc.template_content)
        formData.append('layout', JSON.stringify(layout))
        formData.append('html_content', '<div></div>')
        API.post(SET_LAYOUT, formData)
            .then(data => {
                let res = data.data
                if (res.success == true) {
                    // cogoToast.success(MESSAGE.DRAFT_SAVED)
                    let currentDate = setDate(Date.now())
                    localStorage.setItem(localDataKeys.LAST_SAVE, currentDate)
                }
                else {
                    cogoToast.success("Unable to auto save, please save manually")
                }
            })
    }
    return null;
};

export default useNavigationBlocker;